import HeaderComponent from "../component/HeaderComponent";
import { cdnImg } from "../Utils/cdnImage";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useLocation, useNavigate } from "react-router-dom";
import HomeSlider from "../component/HomeSlider";
import CurrentNew from "../component/CurrentNew";
import Footer from "../component/Footer";
import Menu from "../component/Menu";
import HomeCarousel from "../component/HomeCarousel";
import CasinoOverlay from "./casino/CasinoOverlay";
import Logout from "../component/Logout";
import Announcement from "../component/Announcement";
import PopUp from "./casino/PopUp";
import { isEmpty } from "lodash";
import { isMobile } from "react-device-detect";
import MenuWeb from "../component/MenuWeb";
import Login from "../component/Login";
import ProfileModal from "../component/ProfileModal";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Draggable from "react-draggable";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import CasinoModal from "./Sky/CasinoModal";
import BetSlipContext from "../context/BetSlipContext";

let tawkLoaded = false;

const TAWK_NOOP = () => {};
const DRAG_BOUNDS = { top: -600, left: -250, right: 50, bottom: 25 };
const Layout = ({ children }) => {
  const menuModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.menuModal;
  });
  const showCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.showCasino;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const betLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.betLoader;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const casinoModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.casinoModal;
  });
  const setCasinoModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoModal;
  });
  const logoutShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutShow;
  });
  const casinoBefore = useContextSelector(AuthContext, (ctx) => {
    return ctx.casinoBefore;
  });

  const loginModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.loginModal;
  });
  const profileModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileModal;
  });
  const showCasinoUrl = useContextSelector(AuthContext, (ctx) => {
    return ctx.showCasinoUrl;
  });
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });
  const showParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.showParlyBet;
  });
  const location = useLocation();
  const navigate = useNavigate();
  const tawkMessengerRef = useRef();

  const isHomePage = ["/", "/sports"].includes(location?.pathname);

  const [isCondition, setIsCondition] = useState(true);
  useEffect(() => {
    const checkElement = () => {
      const selectors = [
        ".menu-mask",
        ".s-my-bets-mask",
        ".pop-bg",
        ".s-modal-mask",
        "s-search-mask",
      ];

      const anyVisible = selectors.some((selector) => {
        const el = document.querySelector(selector);
        return el ? window.getComputedStyle(el).display === "block" : false;
      });

      setIsCondition(!anyVisible); // false when any element is visible, true when all hidden
    };

    checkElement();

    const observer = new MutationObserver(() => {
      checkElement();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!tawkLoaded || !tawkMessengerRef.current) return;

    if (
      !isCondition ||
      parlay ||
      showParlyBet ||
      showBetDialog ||
      !isHomePage
    ) {
      tawkMessengerRef.current.hideWidget();
    } else {
      tawkMessengerRef.current.showWidget();
    }
  }, [parlay, isHomePage, isCondition]);

  const background = location.state?.background;
  const condiSports = useMemo(() => {
    const p1 = location?.pathname?.split("/")[1];
    const p2 = background?.pathname?.split("/")[1];
    return (
      ["match-detail", "sports"].includes(p1) ||
      ["match-detail", "sports"].includes(p2)
    );
  }, [location?.pathname, background?.pathname]);

  const cricketWrapStyle = useMemo(
    () =>
      condiSports
        ? { backgroundImage: `url(/assets/images/bg-cricket.jpg)` }
        : {},
    [condiSports],
  );
  const cricketContentStyle = useMemo(
    () => (condiSports ? { background: "transparent" } : {}),
    [condiSports],
  );

  const [showSpin, setShowSpin] = useState(true);
  const [startX, setStartX] = useState(null);
  const [startY, setStartY] = useState(null);

  // ✅ Fix 1: Add nodeRef to avoid findDOMNode deprecation error
  const draggableRef = useRef(null);

  // ✅ Fix 2: onStart receives (e, data) from react-draggable, not touch events
  const handleDragStart = useCallback((e, data) => {
    setStartX(data.x);
    setStartY(data.y);
  }, []);

  // ✅ Fix 3: onStop receives (e, data) from react-draggable
  const handleDragStop = useCallback(
    (e, data) => {
      const endX = data.x;
      const endY = data.y;
      const distance = Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2);
      if (distance < 5) {
        setShowSpin(true);
        isEmpty(user) ? navigate("/login") : navigate("/spin-wheel");
      }
    },
    [startX, startY, user, navigate],
  );

  const openCasinoModal = useCallback(() => {
    setCasinoModal(true);
  }, [setCasinoModal]);

  return (
    <app-root>
      <div
        style={{ position: "relative" }}
        className="main-router-wrapper ng-tns-c3783694019-0 ng-trigger ng-trigger-routeFullPageAni"
      >
        {betLoader && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100vw",
              backgroundColor: "transparent",
              zIndex: 9999,
              cursor: "not-allowed",
            }}
          />
        )}
        <div
          className={
            !isMobile
              ? `layout-desktop ng-tns-c1218069548-2 ${
                  sidebarModal ? "layout-desktop--menu-open" : ""
                }`
              : ""
          }
        >
          <div
            className={
              !isMobile ? "layout-desktop__inner ng-tns-c1218069548-2" : ""
            }
          >
            {isMobile && <Menu />}
            <div
              className={
                !isMobile
                  ? "layout-desktop__main ng-tns-c1218069548-2 ng-trigger ng-trigger-routeLayoutPageAni"
                  : ""
              }
            >
              {!menuModal && <HeaderComponent />}
              <div
                className={
                  isMobile
                    ? "wrap  ng-star-inserted"
                    : `layout-desktop__body ng-tns-c1218069548-2 ${
                        condiSports ? "cricket-bg" : ""
                      }`
                }
                style={cricketWrapStyle}
              >
                <div
                  className={
                    isMobile
                      ? "wrap-inner "
                      : "layout-desktop__body-inner ng-tns-c1218069548-2"
                  }
                >
                  <div
                    className={
                      isMobile
                        ? "content cricket"
                        : "layout-desktop__content ng-tns-c1218069548-2"
                    }
                    style={cricketContentStyle}
                  >
                    {(background?.pathname == "/" ||
                      ["/", "/sports"].includes(location?.pathname)) && (
                      <HomeCarousel />
                    )}
                    {condiSports ? (
                      children
                    ) : (
                      <div
                        id="mainWrapper"
                        className="main-wrapper ng-star-inserted"
                      >
                        {(background?.pathname == "/" ||
                          location?.pathname == "/") && (
                          <>
                            <CurrentNew />
                            {/* <HomeSlider /> */}
                          </>
                        )}

                        {children}
                      </div>
                    )}
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
            {!isMobile && <MenuWeb />}
            {logoutShow && <Logout />}
            {showCasino && !isEmpty(showCasinoUrl) && (
              <CasinoOverlay showCasinoUrl={showCasinoUrl} />
            )}
            {casinoBefore && <PopUp />} {loginModal && <Login />}
            {profileModal && <ProfileModal />}
          </div>
        </div>
      </div>
      <TawkMessengerReact
        propertyId="68a892b1b896631924467f68"
        widgetId="default"
        ref={tawkMessengerRef}
        onBeforeLoad={TAWK_NOOP}
        onStatusChange={TAWK_NOOP}
        onChatMaximized={TAWK_NOOP}
        onChatMinimized={TAWK_NOOP}
        onChatHidden={TAWK_NOOP}
        onChatStarted={TAWK_NOOP}
        onChatEnded={TAWK_NOOP}
        onPrechatSubmit={TAWK_NOOP}
        onOfflineSubmit={TAWK_NOOP}
        onChatMessageVisitor={TAWK_NOOP}
        onChatMessageAgent={TAWK_NOOP}
        onChatMessageSystem={TAWK_NOOP}
        onAgentJoinChat={TAWK_NOOP}
        onAgentLeaveChat={TAWK_NOOP}
        onChatSatisfaction={TAWK_NOOP}
        onVisitorNameChanged={TAWK_NOOP}
        onFileUpload={TAWK_NOOP}
        onTagsUpdated={TAWK_NOOP}
        onUnreadCountChanged={TAWK_NOOP}
        onLoad={() => {
          tawkLoaded = true;

          if (!tawkMessengerRef.current) return;
          if (!isHomePage || showParlyBet || showBetDialog || !isCondition) {
            tawkMessengerRef.current.hideWidget();
          } else {
            tawkMessengerRef.current.showWidget();
          }
        }}
      />
      {!showBetDialog &&
        isHomePage &&
        showSpin &&
        isCondition &&
        !showParlyBet && (
          <Draggable
            nodeRef={draggableRef}
            bounds={DRAG_BOUNDS}
            onStart={handleDragStart}
            onStop={handleDragStop}
          >
            <div ref={draggableRef} className="hot-game float-banner-right">
              {profileData?.freeSpin > 0 && (
                <a className="close">{profileData?.freeSpin}</a>
              )}
              <img
                style={
                  isMobile
                    ? {}
                    : {
                        maxWidth: "6vw",
                        maxWidth: "6vw",
                      }
                }
                src={cdnImg("assets/images/wofSpin.gif")}
                alt=""
              />
            </div>
          </Draggable>
        )}
      {!showBetDialog && isHomePage && isCondition && !showParlyBet && (
        <img
          onClick={openCasinoModal}
          style={
            isMobile
              ? {
                  position: "fixed",
                  right: "60px",
                  zIndex: "999",
                  bottom: "80px",
                }
              : {
                  position: "fixed",
                  right: "60px",
                  zIndex: "999",
                  bottom: "80px",
                  maxWidth: "6vw",
                  maxWidth: "6vw",
                }
          }
          className="icon-promote"
          src={cdnImg("assets/images/promot.gif")}
          alt="mini"
        />
      )}
      {casinoModal && (
        <s-casino>
          <CasinoModal />
        </s-casino>
      )}
    </app-root>
  );
};

export default Layout;
